import { render, staticRenderFns } from "./DataView.vue?vue&type=template&id=7ab3884a&scoped=true"
import script from "./DataView.vue?vue&type=script&lang=js"
export * from "./DataView.vue?vue&type=script&lang=js"
import style0 from "./DataView.vue?vue&type=style&index=0&id=7ab3884a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab3884a",
  null
  
)

export default component.exports